import { GatewayType } from "../types";

/** Human-readable labels for gateway platform types. */
export const GATEWAY_TYPE_LABELS: Record<GatewayType, string> = {
  [GatewayType.APIGEE_EDGE]: "Apigee Edge",
  [GatewayType.APIGEE_OPDK]: "Apigee OPDK",
  [GatewayType.APIGEE_HYBRID]: "Apigee Hybrid",
  [GatewayType.APIGEE_X]: "Apigee X",
};

export const GATEWAY_TYPE_OPTIONS = Object.values(GatewayType);

export function gatewayTypeLabel(type: GatewayType | string | null | undefined): string {
  if (!type) return "";
  const key = type as GatewayType;
  return GATEWAY_TYPE_LABELS[key] ?? String(type);
}
